import React from "react";
import reactStringReplace from "react-string-replace";
import { DA_BasicLink } from "@danishagro/shared/src/components/atoms/BasicLink/BasicLink.component";
import { B2B_SITE_ORIGIN } from "@danishagro/shared/src/constants/urlRoot.constants";
import { DA_NavigationPageSimple } from "@danishagro/shared/src/interfaces/navigationPage.interface";
import S from "./SearchPage.module.scss";

export const _SearchPage = ({
    highlightedString,
    onResultClicked,
    ...props
}: DA_NavigationPageSimple & { highlightedString: string; onResultClicked: () => void }) => {
    return (
        <DA_BasicLink
            onClick={onResultClicked}
            href={`${B2B_SITE_ORIGIN}${props.url}`}
            target="_self"
            className={S.link}
            ariaLabel={props.name}
        >
            <div className={S.data}>
                <div className={S.details}>
                    {reactStringReplace(
                        props.name,
                        new RegExp(`(${highlightedString})`, "ig"),
                        (match, index) => (
                            <b key={index}>{match}</b>
                        )
                    )}
                </div>
            </div>
        </DA_BasicLink>
    );
};
